import React, { useEffect } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { AppContext } from "../../contexts/AppContext";
import { calculateAge } from "../../Services/localStorage.tsx";
import { redirectToRealMe } from "../../Services/apiService.jsx";
import ExternalLink from "../ExternalLink/ExternalLink.tsx";
import BackIconWhite from "../../assets/images/BackIconWhite.svg";

const ApplicationAtStore = ({ handleNext, handleCancel, handleBack }) => {
  const { appState, SetAppState, userFlows } = React.useContext(AppContext);
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 14);
  const [consentRequired, setConsentRequired] = React.useState(false);

  const formattedDate = futureDate.toLocaleDateString("en-NZ", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const applicant = appState?.requestPayload?.applicant;
  console.log(
    " Supporting",
    appState?.requestPayload?.supportingInformation?.nameChangeSourceCode >=
      100000003
  );

  const fullName =
    [applicant?.givenNames, applicant?.familyName].filter(Boolean).join(" ") ||
    "-";

  const givenNameDiff =
    (applicant?.givenNames ?? "").trim().toLowerCase() !==
    (applicant?.namesKnownAs?.[0]?.givenNames ?? "").trim().toLowerCase();

  const familyNameDiff =
    (applicant?.familyName ?? "").trim().toLowerCase() !==
    (applicant?.namesKnownAs?.[0]?.familyName ?? "").trim().toLowerCase();

  console.log({ givenNameDiff, familyNameDiff });

  useEffect(() => {
    const dob = new Date(appState?.requestPayload?.applicant?.dateOfBirth);
    const age = calculateAge(dob);
    if (age < 14) {
      setConsentRequired(true);
    }
  }, [appState?.requestPayload?.applicant?.dateOfBirth]);

  return (
    <>
      <div className="intro">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Whakaotihia tō tono ki tētahi toa rangapū o RealMe
        </h1>
        <hr />
        <h1 className="intro-title">
          Finish your application at a RealMe partner store
        </h1>

        <div className="step-container">
          <div className="step-container-box applicant-details">
            <span className="value">
              <strong>{fullName}</strong>
            </span>
            {(givenNameDiff || familyNameDiff) && (
              <span className="label-noblock">
                Other name:{" "}
                <strong>{`${
                  appState?.requestPayload?.applicant?.namesKnownAs?.[0]
                    ?.givenNames || ""
                } ${
                  appState?.requestPayload?.applicant?.namesKnownAs?.[0]
                    ?.familyName || ""
                }`}</strong>
              </span>
            )}
            <span className="label-noblock">
              Your application number:{" "}
              <strong>{appState?.requestPayload?.applicationId}</strong>
            </span>
          </div>
          <div className="spacer-64"></div>
          {!userFlows?.childApplication && (
            <p className="mb-4">
              We need to check your details in person and take a photo of you to
              complete your application.
            </p>
          )}
          {userFlows?.childApplication && (
            <p className="mb-4">
              Because you're aged 13 years and under, you need to complete your
              application in person with your parent or legal guardian present.{" "}
            </p>
          )}
          {!userFlows?.isRenew && (
            <p className="mb-4">
              We've sent a confirmation email to{" "}
              <b>{appState?.requestPayload?.applicant?.emailAddress}</b> with
              this information.
            </p>
          )}

          <h2 className="step-title mb-2">What you need to do</h2>
          {!userFlows?.childApplication && (
            <p className="mb-4">
              Visit a RealMe partner store before <b>{formattedDate}</b> with:
            </p>
          )}
          {userFlows?.childApplication && (
            <>
              <p className="mb-4">
                Visit a RealMe partner store with your parent or legal guardian
                before <b>{formattedDate}</b> to finish your application and get
                your photo taken.
              </p>
              <p className="mb-4">You need to provide:</p>
            </>
          )}
          <ul className="step-listing">
            <li className="step-item">
              your application number {appState?.requestPayload?.applicationId}
            </li>
            {consentRequired && (
              <li className="step-item">
                a completed{" "}
                <a
                  className="cancel-link"
                  href="https://d2ev5dg63zosux.cloudfront.net/media/documents/Declaration_of_consent_to_an_IVS_application_2018.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  consent form (PDF 99.4KB)
                </a>
                , signed by a parent or legal guardian
              </li>
            )}
            {!userFlows?.isRenew && !userFlows?.noPhotoId && (
              <React.Fragment>
                <li className="step-item">
                  a valid photo ID, including one of the following:
                </li>
                <ul className="step-listing">
                  <li className="step-item">NZ passport</li>
                  <li className="step-item">overseas passport</li>
                  <li className="step-item">certificate of identity</li>
                  <li className="step-item">refugee travel document</li>
                  {!consentRequired && (
                    <React.Fragment>
                      <li className="step-item">current NZ driver licence</li>
                      <li className="step-item">current NZ firearms licence</li>
                      <li className="step-item">
                        Kiwi Access Card (issued after April 2022)
                      </li>
                    </React.Fragment>
                  )}
                </ul>
                <br />
              </React.Fragment>
            )}

            {/* {appState?.requestPayload?.eventTypeSearch?.[1]?.eventTypeId ===
              "b3cbe24e-a934-ed11-9db1-0022489412bc" &&
              new Date(
                appState?.requestPayload?.eventTypeSearch?.[1]?.dateOfEvent
              ).setHours(0, 0, 0, 0) <
                new Date("2009-01-01").setHours(0, 0, 0, 0) && (
                <React.Fragment>
                  <li className="step-item">proof of your name change</li>
                </React.Fragment>
              )} */}
            {appState?.requestPayload?.supportingInformation
              ?.nameChangeSourceCode >= 100000003 && (
              <React.Fragment>
                <li className="step-item">proof of your name change</li>
              </React.Fragment>
            )}
            {(appState?.requestPayload?.supportingInformation
              ?.genderSourceCode === 100000002 ||
              appState?.requestPayload?.supportingInformation
                ?.genderSourceCode === 100000003) && (
              <li className="step-item">proof of your gender change</li>
            )}
          </ul>
          <br />
          <div className="checkbox-wrapper mb-16">
            <label className="terms-label">
              You must provide original documents. If you do not have a valid
              photo ID,&nbsp;
              <ExternalLink
                href="https://www.realme.govt.nz/contact-us/"
                text="contact us"
              />
            </label>
          </div>
          <div className="checkbox-wrapper mb-5">
            <label className="terms-label">
              <ExternalLink
                href="https://www.realme.govt.nz/how-apply/find-participating-photostore/"
                text="Find a RealMe partner store"
              />
            </label>
          </div>
        </div>
      </div>

      <div className="step-button-container">
        <SubmitButton
          text={"Back to RealMe"}
          onClick={redirectToRealMe}
          Icon={BackIconWhite}
        />
      </div>
    </>
  );
};

export default ApplicationAtStore;
